import {
  Flex,
  Text,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
} from '@chakra-ui/react';
import { useState } from 'react';

interface AdjustAmountRowProps {
  name: string;
  accumulatedAmount: number;
  onAdditionalAmountChangeParent: (name: string, newAmount: number) => void;
}

const AdjustAmountRow: React.FC<AdjustAmountRowProps> = ({
  name,
  accumulatedAmount,
  onAdditionalAmountChangeParent,
}) => {
  const [currentAdditionalAmount, setCurrentAdditionalAmount] = useState(0);
  const onAdditionalAmountChange = (
    name: string,
    newAdditionalAmount: number,
  ) => {
    setCurrentAdditionalAmount(newAdditionalAmount);
    onAdditionalAmountChangeParent(name, newAdditionalAmount);
  };

  return (
    <Flex direction="row" gap={4} align="center">
      <Text width="40%">{name}</Text>
      <Text width="30%">{accumulatedAmount}</Text>
      <NumberInput
        width="30%"
        value={currentAdditionalAmount}
        onChange={(_, valueAsNumber) =>
          onAdditionalAmountChange(name, valueAsNumber)
        }
        step={1}
        min={-1000}
        max={1000}
        clampValueOnBlur={true}
      >
        <NumberInputField />
        <NumberInputStepper>
          <NumberIncrementStepper />
          <NumberDecrementStepper />
        </NumberInputStepper>
      </NumberInput>
    </Flex>
  );
};

export default AdjustAmountRow;
